import {
  ClearButtons,
  FormatButtons,
  LevelSelect,
  LinkButtons,
  ListButtons,
  QuoteButtons,
  RichTextInput,
  RichTextInputToolbar,
} from "ra-input-rich-text";
import * as React from "react";
import {
  ArrayInput,
  AutocompleteInput,
  Create,
  CreateProps,
  ReferenceInput,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  TranslatableInputs,
  useLocaleState,
} from "react-admin";

const FaqCreate = (props: CreateProps) => {
  const [locale] = useLocaleState();

  return (
    <Create {...props} mutationOptions={{ meta: { fileUpload: true } }}>
      <SimpleForm style={{ display: "flex", width: "100%" }}>
        <ReferenceInput source="banner" reference="banners">
          <AutocompleteInput
            fullWidth
            label="faq.banner"
            optionText={`bannerTitle.${locale}`}
          />
        </ReferenceInput>
        <TranslatableInputs fullWidth defaultLocale={locale} locales={["pl"]}>
          <TextInput fullWidth source="sectionTitle" label="faq.title" />
          <TextInput fullWidth source="sectionSubtitle" label="faq.subtitle" />
          <ArrayInput source="faq">
            <SimpleFormIterator fullWidth>
              <TextInput fullWidth source="question" label="faq.question" />
              <RichTextInput
                toolbar={
                  <RichTextInputToolbar>
                    <LevelSelect />
                    <FormatButtons />
                    <ListButtons />
                    <LinkButtons />
                    <QuoteButtons />
                    <ClearButtons />
                  </RichTextInputToolbar>
                }
                fullWidth
                source="answer"
                label="faq.answer"
              />
            </SimpleFormIterator>
          </ArrayInput>
        </TranslatableInputs>
      </SimpleForm>
    </Create>
  );
};

export default FaqCreate;
